import axios from 'axios';

import config from '@/helpers/config';
import storage from './storage';

const configuration = config();
const BASE_PATH = configuration.MASTERDATA_API;
export interface BasicInfo {
    Name: string,
    Eval: boolean,
    Supplier: boolean,
    Customer: boolean,
    Raise: boolean,
    UnLock: boolean,
    UnLockSup: boolean,
    updateCC: boolean,
}
export interface NewCustomerKnownValues {
    FreitsCustomer: boolean,
    Address1: string,
    Address2: string,
    Mobil: string,
    Email: string,
    ZIP: string,
    Phone: string,
    City: string,
    Area: string,
    Lingua: string,
    GreenMove: string,
    Payment: string,
    Terms: string,
    Invoicing: string,
    Priority: string,
    Iban: string,
    InvoiceMail: string,
    AdministrativMail: string,
    CreditLimitNote: string,
    CreditLimit: string,
    PECEmail: string,
    SDICode: string
}
export interface NewCustomerFormAndRequest extends NewCustomerKnownValues{
    customercare_FTL: string,
    customercare_LTL: string,
    customercare_XTL: string,
    customercare_PAO: string,
    PaymentNote: string,
    pdfFile: [],
    pdfFileName: string,
}
export interface NewCustomerListContent {
    GreenMove: ListElement[],
    Invoicing: ListElement[],
    Priority: ListElement[],
    Lingua: ListElement[],
    Filiali: ListElementBase[],
    Agenti: ChildListElement[],
    Payment: ChildListElement[],
    Terms: ChildListElement[],
}
// newSupplier
export interface NewSupplierKnownValues {
    Address1: string,
    Address2: string,
    Mobil: string,
    Email: string,
    ZIP: string,
    Phone: string,
    City: string,
    Area: string,
    Lingua: string,
    Payment: string,
    Terms: string,
    Iban: string,
    TransportLicense: string,
    PaymentNotific: string,
    NotificationEmail: string,
    CmrReminder: string,
  }
export interface NewSupplierListContent {
    Payment: ChildListElement[],
    Terms: ChildListElement[],
    Lingua: ListElement[],
}
export interface NewSupplierFormAndRequest extends NewSupplierKnownValues {
    PaymentNote: string,
    pdfFile: [],
    pdfFileName: string,
}
export interface CompanyListItem {
    RagioneSociale: string,
    Cap: string,
    Localita: string
    lingua: string,
    BloccatoMotivo: string,
    SocietaCollegamento: number,
    ClienteFornitoreCodice: number,
    ClienteFornitore: string,
    Nazione: string,
    Outdated: boolean
}
export interface ListContentResponseModelULC {
    GreenMove: ListElement[],
    Invoicing: ListElement[],
    Payment: ChildListElement[],
    Terms: ChildListElement[],
    Lingua: ListElement[],
}
export interface KnownValuesResponseModelULC {
    Address1: string,
    Address2: string,
    Mobil: string,
    Email: string,
    ZIP: string,
    Phone: string,
    City: string,
    Area: string,
    Lingua: string,
    GreenMove: string,
    Payment: string,
    Terms: string,
    Invoicing: string,
    Iban: string,
    CreditLimitNote: string,
    CreditLimit: string,
    PECEmail: string,
    SDICode: string,
}
export interface ULCFormandRequest extends KnownValuesResponseModelULC{
    pdfFile: [],
    pdfFileName: string,
    step2: boolean,
    SocietaCollegamento: number,
    ClienteFornitoreCodice: number,
    PaymentNote: string,
    date: Date,
}
// Raise Credit
export interface RCCompanyListItem extends CompanyListItem {
    Fido: number,
    Importo: number
}
// Base Elements
export interface MDServerResponse {
    TypeOfActivation: number,
    Codice: string,
}
export interface ListElementBase {
    Codice: string,
    Descrizione: string,
}
export interface ListElement{
    Default: boolean,
    Verification: boolean,
    Codice: string,
    Descrizione: string,
}
export interface ChildListElement{
    Default: boolean,
    Verification: boolean,
    Codice: string,
    Descrizione: string,
    ParentCode: string,
}
export interface UpdateCCRequest{
    customercare_FTL: string,
    customercare_LTL: string,
    customercare_XTL: string,
    customercare_PAO: string,
    date: Date,
}
const addAuth = () => {
    axios.defaults.headers.common['X-ZUMO-AUTH'] = storage.getUser().auth_token;
    axios.defaults.headers.common['ZUMO-API-VERSION'] = '2.0.0';
};
const getNCKnownValues = async (code: number, societa: number, socetaUser: number): Promise<NewCustomerKnownValues | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/customer/knownValues?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getCustomerListContent = async (code: number, societa: number, socetaUser: number): Promise<NewCustomerListContent | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/customer/listsContent?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getNSKnownValues = async (code: number, societa: number, socetaUser: number): Promise<NewSupplierKnownValues | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/supplier/knownValues?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getNSListContent = async (code: number, societa: number, socetaUser: number): Promise<NewSupplierListContent | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/supplier/listsContent?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const sendDataNS = async (code: number, societa: number, socetaUser: number, form: NewSupplierFormAndRequest): Promise<MDServerResponse> => {
    addAuth();
    try {
        const response = await axios.post(`${BASE_PATH}/supplier/creatOrUnlock?societaUser=${socetaUser}&societa=${societa}&codice=${code}&userlanguage=${localStorage.userLanguage}`, form, { timeout: 60000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getULCCompanyList = async (code: number, societa: number, socetaUser: number): Promise<[CompanyListItem] | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/unlock/companies?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 30000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getULCKnownValues = async (code: number, societa: number, socetaUser: number, baCliForCodice: number, societaCollegamento: number): Promise<KnownValuesResponseModelULC | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/unlock/knownValues?societaUser=${socetaUser}&societa=${societa}&codice=${code}&baCliForCodice=${baCliForCodice}&societaCollegamento=${societaCollegamento}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const sendDataCustomer = async (code: number, societa: number, socetaUser: number, form: ULCFormandRequest): Promise<MDServerResponse> => {
    addAuth();
    try {
        const response = await axios.post(`${BASE_PATH}/customer/creatOrUnlock?societaUser=${socetaUser}&societa=${societa}&codice=${code}&userlanguage=${localStorage.userLanguage}`, form, { timeout: 60000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getULSSupplierList = async (code: number, societa: number, socetaUser: number): Promise<[CompanyListItem] | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/unlock/companies?societaUser=${socetaUser}&societa=${societa}&codice=${code}&supplier=${true}`, { timeout: 30000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getULSKnownValues = async (code: number, societa: number, socetaUser: number, baCliForCodice: number, societaCollegamento: number): Promise<KnownValuesResponseModelULC | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/unlock/knownValues?societaUser=${socetaUser}&societa=${societa}&codice=${code}&baCliForCodice=${baCliForCodice}&societaCollegamento=${societaCollegamento}&supplier=${true}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getRCCompanyList = async (code: number, societa: number, socetaUser: number): Promise<[RCCompanyListItem] | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/raiseCredit/companies?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 3000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const sendDataRC = async (code: number, societa: number, socetaUser: number, requestedCredit: number, BaCliForCodice: number, societaCollegamento: number, CreditLimitNote: string): Promise<MDServerResponse> => {
    addAuth();
    try {
        const response = await axios.put(`${BASE_PATH}/raiseCredit/raiseCredit?societaUser=${socetaUser}&societa=${societa}&codice=${code}&requestedCredit=${requestedCredit}&BaCliForCodice=${BaCliForCodice}&societaCollegamento=${societaCollegamento}&creditLimitNote=${CreditLimitNote}&userlanguage=${localStorage.userLanguage}`, { timeout: 60000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getEvaluateCustomer = async (code: number, societa: number, socetaUser: number, notes: string): Promise<MDServerResponse | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/evaluateCustomer?societaUser=${socetaUser}&societa=${societa}&codice=${code}&urgent=${true}&notes=${notes}&userlanguage=${localStorage.userLanguage}`, { timeout: 60000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const sendUpdateCC = async (code: number, societa: number, socetaUser: number, form: UpdateCCRequest): Promise<MDServerResponse | undefined> => {
    addAuth();
    try {
        const response = await axios.put(`${BASE_PATH}/customer/updateCustomerCare?societaUser=${socetaUser}&societa=${societa}&codice=${code}&userlanguage=${localStorage.userLanguage}`, form, { timeout: 60000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getbasicInfo = async (code: number, societa: number, socetaUser: number): Promise<BasicInfo | undefined> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/companyEnabledFeatures?societaUser=${socetaUser}&societa=${societa}&codice=${code}`, { timeout: 60000 });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const getIbanCheck = async (iban: string): Promise<any> => {
    addAuth();
    try {
        const response = await axios.get(`${BASE_PATH}/iban?Iban=${iban}`, { timeout: 3000 });
        return response.data.validations;
    } catch (error) {
        throw error;
    }
};
const isIbanCheckSuccses = (ibanvalidation: any): boolean => {
    if (!ibanvalidation.chars.code.startsWith('00')) {
        return false;
    }
    if (!ibanvalidation.country_support.code.startsWith('00')) {
        return false;
    }
    if (!ibanvalidation.iban.code.startsWith('00')) {
        return false;
    }
    if (!ibanvalidation.length.code.startsWith('00')) {
        return false;
    }
    if (!ibanvalidation.structure.code.startsWith('00')) {
        return false;
    }
    if (!ibanvalidation.account.code.startsWith('00')) {
        return false;
    }
    return true;
};
const errorMessageAlert = (mDComponent: any, error: any, loading: any, titel: string, body: string, goBack: boolean = true) => {
    let data: any;
    let status: number;
    if (error.response != null) {
        data = error.response.data;
        status = error.response.status;
        if (data.Message != null) {
            data = data.Message;
        }
    } else {
        data = mDComponent.$t('masterData.TimeOutError');
        status = 0;
    }
    if (data.Codice != null) {
        mDComponent.$alert(`${mDComponent.$t(`masterDataErrorCodes.${data.Codice}`)}`, `${mDComponent.$t(titel)} ${status}`, {
            type: 'error',
            confirmButtonText: 'OK',
            center: true,
            callback: (action: any) => {
                loading.close();
                if (goBack) mDComponent.$router.go(-1);
            },
        });
    } else {
        mDComponent.$alert(`${mDComponent.$t(body)} "${data}"`, `${mDComponent.$t(titel)} ${status}`, {
            type: 'error',
            confirmButtonText: 'OK',
            center: true,
            callback: (action: any) => {
                loading.close();
                if (goBack) mDComponent.$router.go(-1);
            },
        });
    }
};

const showSuccess = (mDComponent: any, response: MDServerResponse) => {
    let type = '';
    switch (response.TypeOfActivation) {
    default:
        type = 'error'; break;
    case 0:
        type = 'success'; break;
    case 1:
        type = 'warning'; break;
    case 2:
        type = 'warning'; break;
    case 3:
        type = 'error'; break;
    }
    mDComponent.$alert(`${mDComponent.$t(`masterDataTypeOfActivationMessage.message${response.TypeOfActivation}`)}${response.Codice}`, mDComponent.$t(`masterDataTypeOfActivationMessage.message${response.TypeOfActivation}Titel`), {
        type,
        confirmButtonText: 'OK',
        center: true,
        callback: (action: any) => {
            mDComponent.$router.push('/masterdata');
        },
    });
};
const readUploadedFileAsArrayBuffer = (inputFile: Blob): any => {
    const temporaryFileReader = new FileReader();

    return new Promise((resolve, reject) => {
        temporaryFileReader.onerror = () => {
            temporaryFileReader.abort();
            reject(new DOMException('Problem parsing input file.'));
        };

        temporaryFileReader.onload = () => {
            resolve(temporaryFileReader.result);
        };
        temporaryFileReader.readAsArrayBuffer(inputFile);
    });
};
export default {
    getNCKnownValues,
    getCustomerListContent,
    getIbanCheck,
    getNSKnownValues,
    getNSListContent,
    sendDataNS,
    sendDataCustomer,
    getULCCompanyList,
    getULCKnownValues,
    getRCCompanyList,
    sendDataRC,
    getEvaluateCustomer,
    errorMessageAlert,
    showSuccess,
    isIbanCheckSuccses,
    readUploadedFileAsArrayBuffer,
    getbasicInfo,
    getULSKnownValues,
    getULSSupplierList,
    sendUpdateCC,
};
